export const getTicketDisponibility = (
  quantityAvailable,
  unlimited,
  soldOut,
  hasExpired,
  limited,
) => {
  let text = '';

  // eslint-disable-next-line eqeqeq
  if (quantityAvailable == 0) {
    text = ` — ${I18n.t('web.networks.events.tickets.list.remaining.zero', {
      count: quantityAvailable,
    })}`;
    // eslint-disable-next-line eqeqeq
  } else if (quantityAvailable == 1) {
    text = ` — ${I18n.t('web.networks.events.tickets.list.remaining.one', {
      count: quantityAvailable,
    })}`;
  } else {
    text = ` — ${I18n.t('web.networks.events.tickets.list.remaining.other', {
      count: quantityAvailable,
    })}`;
  }

  if (hasExpired) {
    text = ` — ${I18n.t('web.networks.events.tickets.list.expired')}`;
  } else if (unlimited) {
    text = '';
  } else if (limited) {
    text = ` — ${I18n.t('web.networks.events.tickets.list.limit_by_user')}`;
  } else if (soldOut) {
    text = ` — ${I18n.t('web.networks.events.tickets.list.sold_out')}`;
  }

  return text;
};
